// eslint-disable-next-line no-unused-vars
import { Display } from './Display';

/**
 * Create global variables that contain the Displays
 * @param {Display} display
 * @deprecated these variables should not be used
 */
export function setWindowVariables(display) {
    // !!! side-effects
    if (!window['displays_array']) {
        window['displays_array'] = [];
    }

    window['display_var_' + display.id] = display;
    window['displays_array'].push(display);

    // required for side-effects from ZoneFactory
    window['display_zone_array_' + display.id] = [];
}
